import { IFormattingSettings, UnitSystemType } from '@fulcrum/lib';
import { ExtendedFormattingSettings, FormattingSettings } from '@trimble/types';
import { UnreachableCaseError } from 'ts-essentials';

export const DEFAULT_FORMATTING_SETTINGS: FormattingSettings = {
  unitSystem: 'metric',
  lengthUnit: 'm',
  lengthDecimals: 3,
  lengthFormatting: 'decimal',
  lengthFractions: 16,
  lengthMeasurementUnit: 'm',
  lengthMeasurementDecimals: 3,
  lengthMeasurementFormatting: 'decimal',
  lengthMeasurementFractions: 16,
  areaUnit: 'm2',
  areaDecimals: 3,
  volumeUnit: 'm3',
  volumeDecimals: 3,
  massUnit: 'kg',
  massDecimals: 2,
  angleUnit: 'deg',
  angleDecimals: 2,
};

export const DEFAULT_FORMATTING_SETTINGS_INTERNATION_FOOT: FormattingSettings =
  {
    unitSystem: 'imperial',
    lengthUnit: 'ft',
    lengthDecimals: 3,
    lengthFormatting: 'decimal',
    lengthFractions: 16,
    lengthMeasurementUnit: 'ft',
    lengthMeasurementDecimals: 3,
    lengthMeasurementFormatting: 'decimal',
    lengthMeasurementFractions: 16,
    areaUnit: 'ft2',
    areaDecimals: 3,
    volumeUnit: 'ft3',
    volumeDecimals: 3,
    massUnit: 'lb',
    massDecimals: 2,
    angleUnit: 'deg',
    angleDecimals: 2,
  };

export const DEFAULT_FORMATTING_SETTINGS_US_SURVEY_FOOT: FormattingSettings = {
  unitSystem: 'ussurveyfeet',
  lengthUnit: 'sFT',
  lengthDecimals: 3,
  lengthFormatting: 'decimal',
  lengthFractions: 16,
  lengthMeasurementUnit: 'sFT',
  lengthMeasurementDecimals: 3,
  lengthMeasurementFormatting: 'decimal',
  lengthMeasurementFractions: 16,
  areaUnit: 'ft2',
  areaDecimals: 3,
  volumeUnit: 'ft3',
  volumeDecimals: 3,
  massUnit: 'lb',
  massDecimals: 2,
  angleUnit: 'deg',
  angleDecimals: 2,
};

export const DEFAULT_FORMATTING_SETTINGS_EXT: ExtendedFormattingSettings = {
  ...DEFAULT_FORMATTING_SETTINGS,
  coordinateOrder: { order: 'NEZ' },
  slopeMeasurementSettings: {
    format: 'degrees',
    displayMode: 0,
  },
};

export function getFormattingSystemDefaults(
  unitSystem: UnitSystemType
): IFormattingSettings {
  switch (unitSystem) {
    case 'metric':
      return DEFAULT_FORMATTING_SETTINGS;
    case 'imperial':
      return DEFAULT_FORMATTING_SETTINGS_INTERNATION_FOOT;
    case 'ussurveyfeet':
      return DEFAULT_FORMATTING_SETTINGS_US_SURVEY_FOOT;
    case 'custom':
      return { ['unitSystem' as keyof IFormattingSettings]: unitSystem };
    default:
      throw new UnreachableCaseError(unitSystem);
  }
}
